// Order 狀態機（純函數）
// see architecture.md#L510

export const ORDER_STATES = Object.freeze({
  PENDING: 'pending',
  PAID: 'paid',
  PREPARING: 'preparing',
  READY: 'ready',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
});

const TRANSITIONS = {
  // QR 匿名訂單：pending 可直轉 preparing（店員面收現金，隱含 paid）
  [ORDER_STATES.PENDING]: [ORDER_STATES.PAID, ORDER_STATES.PREPARING, ORDER_STATES.CANCELLED],
  [ORDER_STATES.PAID]: [ORDER_STATES.PREPARING, ORDER_STATES.REFUNDED],
  [ORDER_STATES.PREPARING]: [ORDER_STATES.READY, ORDER_STATES.CANCELLED],
  [ORDER_STATES.READY]: [ORDER_STATES.COMPLETED],
  [ORDER_STATES.COMPLETED]: [ORDER_STATES.REFUNDED],
  [ORDER_STATES.CANCELLED]: [],
  [ORDER_STATES.REFUNDED]: [],
};

export function canTransition(from, to) {
  return TRANSITIONS[from]?.includes(to) ?? false;
}

export function nextStates(from) {
  return TRANSITIONS[from] ?? [];
}

export function isTerminal(state) {
  return TRANSITIONS[state]?.length === 0;
}

// B2（含電子付款訂單未付款不得出餐）：pending 的 ecpay/linepay/mixed 訂單在完成線上
//   收款前，僅允許前進到 paid（標記付款）或 cancelled，不得跳過付款直接出餐。
//   純判斷函式，UI 與 dynamic/static 兩條 transition 來源共用；後端
//   change_order_status 為最終守門（此處僅讓 UI 一致、避免按了才報錯）。
//   與後端守門一致：'mixed' 含電子分量也受限；僅 cash / 未指定（面收結帳）不受限。
const PREPAID_METHODS = new Set(['ecpay', 'linepay', 'mixed']);
export function isTransitionAllowedForPayment(toState, currentState, paymentMethod) {
  if (currentState === ORDER_STATES.PENDING && PREPAID_METHODS.has(paymentMethod)) {
    return toState === ORDER_STATES.PAID || toState === ORDER_STATES.CANCELLED;
  }
  return true;
}

// Helper: 依照 role 決定可執行哪些 transition
export function allowedTransitionsForRole(currentState, role) {
  const all = nextStates(currentState);
  if (role === 'owner') return all;
  if (role === 'cashier') {
    // cashier 只能改到 preparing / ready
    return all.filter((s) => ['preparing', 'ready', 'completed'].includes(s));
  }
  if (role === 'kitchen') {
    return all.filter((s) => ['ready'].includes(s));
  }
  return [];
}
